import listActions from 'src/modules/affirmationProgramEntitlement/list/affirmationProgramEntitlementListActions';
import AffirmationProgramEntitlementService from 'src/modules/affirmationProgramEntitlement/affirmationProgramEntitlementService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'ENTITLEMENT_DESTROY';

const affirmationProgramEntitlementDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type:
          affirmationProgramEntitlementDestroyActions.DESTROY_STARTED,
      });

      await AffirmationProgramEntitlementService.destroyAll(
        [id],
      );

      dispatch({
        type:
          affirmationProgramEntitlementDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n(
          'entities.affirmationProgramEntitlement.destroy.success',
        ),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/affirmation-program-entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          affirmationProgramEntitlementDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type:
          affirmationProgramEntitlementDestroyActions.DESTROY_ALL_STARTED,
      });

      await AffirmationProgramEntitlementService.destroyAll(
        ids,
      );

      dispatch({
        type:
          affirmationProgramEntitlementDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n(
          'entities.affirmationProgramEntitlement.destroyAll.success',
        ),
      );

      getHistory().push('/affirmation-program-entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          affirmationProgramEntitlementDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default affirmationProgramEntitlementDestroyActions;
